import React from 'react';
import SectionTitle from '../../../components/section-title';
import ContentSlider from '../../../components/content-slider';
import VedantaHighlightsColOne from '../../../content/overview/vedanta-at-glance/vedanta-highlight-col-one';
import VedantaHighlightsColTwo from '../../../content/overview/vedanta-at-glance/vedanta-highlight-col-two';
import VedantaHighlightsColThree from '../../../content/overview/vedanta-at-glance/vedanta-highlight-col-three';
import CollapseMobile from '../../../components/collapse-mobile';

const VedantAtGlance = () => {
  const slider = {
    slides: [<VedantaHighlightsColOne />, <VedantaHighlightsColTwo />, <VedantaHighlightsColThree />],
  };

  const breakpoint = [
    {
      breakpoint: 480,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: '60px',
      },
    },
  ];
  return (
    <div className="overview-page-vedant-at-glance">
      <div className="container">
        <div className="container-inner">
          <div className="content-row">
            <SectionTitle
              label="VEDANTA AT A GLANCE"
              lighttext="A WORLD-CLASS"
              boldtext="NATURAL RESOURCES POWERHOUSE"
              iconimage="icon-natural-resouces-ved.png"
              maxwidth="84"
              alt="Vedanta at a glance"
            />

            <div className="section-description">
              <p>
                Vedanta Limited is one of the world’s largest suppliers of natural resources, with primary operations in
                zinc-lead-silver, iron ore, steel, copper, aluminium, power, oil and gas. Our strategic capabilities and
                alliances are singularly focused on creating and preserving value for our esteemed clients and the wider
                stakeholder fraternity. Together, we help the world grow in a responsible manner.
                <CollapseMobile>
                  <br />
                  <br />
                  Our portfolio of world-class, low-cost, scalable assets consistently generate strong profitability and
                  deliver robust cash flows. Our core divisions have industry-leading market shares, and we continuously
                  strive to raise the bar across our wide canvas of operations
                </CollapseMobile>
              </p>
            </div>
          </div>
          <div className="vedanta-at-glance-highlights-slider">
            <ContentSlider
              data={slider.slides}
              slidesToShow={3}
              slidesToScroll={3}
              prevBtn="blue-prev-btn"
              nextBtn="blue-next-btn"
              customClass="blue-dots-slider"
              responsive={breakpoint}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VedantAtGlance;
